module.exports = __webpack_public_path__ + "static/media/authenticator.538d0707.png";